export const throttle=function(fn, delay){
  let valid = true
  return function () {
    let context = this
    let args = arguments
    if (!valid) return false
    valid = false
    setTimeout(() => {
      fn().apply(context,args)
      valid = true
    }, delay)
  }
}
export const debounce=function(fn, delay){
  let timer = null
  return function() {
    let context = this
    let args = arguments
    clearTimeout(timer)

    timer = setTimeout(()=>{
      fn.apply(context,args)
    },delay)
  }
}
